// extracted by mini-css-extract-plugin
export default {"alienImage":"AnimatedAlienImage_alienImage__Trdg4"};